var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nuxt-link',{class:[_vm.$style.link, _vm.classDevice(_vm.$style)],attrs:{"to":_vm.to}},[_vm._v("Подробнее")])}
var staticRenderFns = []

export { render, staticRenderFns }